import { render, staticRenderFns } from "./KioskBooking.vue?vue&type=template&id=1b1b3930&scoped=true"
import script from "./KioskBooking.vue?vue&type=script&lang=js"
export * from "./KioskBooking.vue?vue&type=script&lang=js"
import style0 from "./KioskBooking.vue?vue&type=style&index=0&id=1b1b3930&prod&scoped=true&lang=css"
import style1 from "./KioskBooking.vue?vue&type=style&index=1&id=1b1b3930&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b1b3930",
  null
  
)

export default component.exports